import { registerBlockType } from "@wordpress/blocks";
import config, { type BlockAttributes } from "./block.json";
import ParallaxEditor from "./parallaxEditor";
import { InnerBlocks } from "@wordpress/block-editor";

registerBlockType<BlockAttributes>(config.name, {
  ...config,

  edit: ParallaxEditor,
  save(props) {
    return <InnerBlocks.Content />;
  },
});
